module.exports = __webpack_public_path__ + "img/DK.9a973d25.svg";